import { createContext, type Dispatch, type SetStateAction } from "react";

import type { CognitoUser } from "amazon-cognito-identity-js";

import type { CognitoUserExtended } from "../../api/auth";

type AuthStateContextProps = {
  authState: AuthState;
  cognitoUser?: CognitoUserExtended;
  setAuthState: Dispatch<SetStateAction<AuthState>>;
  setCognitoUser: Dispatch<SetStateAction<CognitoUser | undefined>>;
};

export enum AuthState {
  LOGIN = "LOGIN",
  SIGNUP = "SIGNUP", // todo: implement signup flow
  FORGOT_PASSWORD = "FORGOT_PASSWORD",
  MFA = "MFA",
  MFA_RECOVERY = "MFA_RECOVERY",
}

export const DEFAULT_AUTH_CONTEXT: AuthStateContextProps = {
  authState: AuthState.LOGIN,
  cognitoUser: undefined,
  setAuthState: () => {},
  setCognitoUser: () => {},
};

export const AuthContext =
  createContext<AuthStateContextProps>(DEFAULT_AUTH_CONTEXT);
